const configEndpoints = {
  configs: '/config',
  budgeting: '/config/budgeting',
  cashFlowStatement: '/config/cash-flow-statement',
  financialStatement: '/config/financial-statement',
  liabilityMapping: '/config/liability-mapping'
}

export default configEndpoints
